import * as React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";
import "./popup.css";
import { API_URL, BOOK_ACCESS } from "../../utils/constants";
import { logError } from "../../utils/errorTracker";

const CancelSubscriptionPopUp = ({
  handleCancelSubPopupVisibility,
  userStripeId,
}: any) => {
  const handleCloseClick = () => {
    handleCancelSubPopupVisibility(false);
  };

  const cancelSubscription = async (userStripeId: any) => {
    try {
      const response = await fetch(`${API_URL}/api/cancel-subscription`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ userStripeId, bookToAccess: BOOK_ACCESS }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseJson = await response.json();
      alert(responseJson.body.message);
    } catch (error) {
      console.error(
        "❌ CancelSubscription: Error canceling subscription:",
        error
      );
      console.error("❌ CancelSubscription: Error details:", {
        message: error instanceof Error ? error.message : "Unknown error",
        userStripeId: userStripeId,
        apiUrl: `${API_URL}/api/cancel-subscription`,
      });

      // Log error to tracker
      logError(
        "CancelSubscription",
        "API_ERROR",
        "Error canceling subscription",
        {
          apiUrl: `${API_URL}/api/cancel-subscription`,
          userStripeId: userStripeId,
          stack: error instanceof Error ? error.stack : undefined,
          message: error instanceof Error ? error.message : "Unknown error",
        }
      );

      alert("Der opstod en fejl under afmelding af abonnement. Prøv igen.");
    }
  };

  return (
    <Modal show={true} className="profileModal">
      <Modal.Header>
        <Modal.Title>Afmeld abonnement</Modal.Title>
        <button
          onClick={handleCloseClick}
          type="button"
          className="btn btn-secondary commonBtn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>Er du sikker på du vil afmelde dit abonnement?</p>
        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-secondary commonBtn"
              onClick={() => cancelSubscription(userStripeId)}
            >
              Bekræft
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelSubscriptionPopUp;
